<div
    provideParentForm
    class="avi-repeated-collection-dropdowns-grid"
>
    <avi-data-grid
        [config]="repeatedDropdownsGridConfig"
        [rows]="dropdownRows"
        [gridTitle]="gridTitle"
        (onRowOrderChange)="handleRowReordering($event)"
    >
        <avi-data-grid_actions>
            <cds-button
                (click)="addDropdown()"
                [disabled]="disabled || hasMaxRows"
                size="sm"
            >
                {{ globalL10nKeys.addLabel | vtranslate }}
            </cds-button>
        </avi-data-grid_actions>
        <ng-template
            #collectionDropdownTemplateRef
            let-row
            let-index="index"
        >
            <avi-collection-dropdown
                placeholder="{{ placeholder }}"
                [name]="name + '-' + (row.uniqueId || index)"
                [multiple]="multiple"
                [collection]="collection"
                [hideSearch]="hideSearch"
                [readonly]="readonly"
                [disabled]="disabled"
                [(ngModel)]="row.value"
                (ngModelChange)="handleRowModelChange()"
                [disableCreate]="disableCreate"
                [disableEdit]="disableEdit"
                required
            ></avi-collection-dropdown>
        </ng-template>
    </avi-data-grid>
</div>
